import { useEffect, useState } from 'react'
import HeroGeometric from './HeroGeometric.jsx'
import { KineticTextReveal } from './KineticTextReveal.jsx'
import { ArrowIcon } from './ui.jsx'

function prefersGentleHeroMotion() {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return true
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
    || navigator.connection?.saveData === true
}

export function Hero() {
  const [gentleMotion, setGentleMotion] = useState(prefersGentleHeroMotion)

  useEffect(() => {
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)')
    const connection = navigator.connection
    const update = () => setGentleMotion(
      reducedMotion.matches || connection?.saveData === true,
    )

    reducedMotion.addEventListener('change', update)
    connection?.addEventListener?.('change', update)
    update()
    return () => {
      reducedMotion.removeEventListener('change', update)
      connection?.removeEventListener?.('change', update)
    }
  }, [])

  const content = (
    <>
      <div className="hero-fade" aria-hidden="true" />
      <div className="shell hero-layout" id="top">
        <div className="hero-copy">
          <p className="eyebrow">Private build · agentic stablecoin commerce</p>
          <h1>
            <KineticTextReveal
              className="hero-title"
              delay={0.12}
              distance={22}
              stagger={0.06}
              text="Stablecoin rails for agents."
            />
          </h1>
          <p className="hero-summary">
            SettlementOS is building the paid-API loop agents are missing: challenge, authorize,
            settle, and verify—with institutional issuance as the trust base.
          </p>
          <div className="hero-actions">
            <a className="button button-blue" href="#demo">Book a demo <ArrowIcon /></a>
            <a className="quiet-link" href="#products">Explore the platform <ArrowIcon /></a>
          </div>
        </div>
        <div className="hero-foot">
          <span>01 / CONTROL OFF-CHAIN</span>
          <span>02 / EXECUTION MIXED</span>
          <span>03 / SETTLEMENT ON-CHAIN</span>
        </div>
      </div>
    </>
  )

  return (
    <HeroGeometric
      className="hero"
      color1="#9bdfff"
      color2="#82dfa7"
      speed={gentleMotion ? 0.28 : 1}
    >
      {content}
    </HeroGeometric>
  )
}
